import service from "./api.service";

class UserEvaluationService {
  static getEvaluationList = () => {
    return service.get("userevaluation");
  };
}

export default UserEvaluationService;
